export default __webpack_public_path__ + "static/media/Kahf2.40143de1.mp3";